import { Editor } from "@monaco-editor/react";
import { withJsonEditor } from "@monaco-editor-enhancer/json-editor";

const JsonEditor = withJsonEditor(Editor, "onMount");

export default function MyEditor(props: {
  value: string | null;
  onChange: (value: string | null) => void;
  schemaUri: `http://${string}` | `https://${string}`;
}) {
  return (
    <JsonEditor
      height={"100%"}
      width={"100%"}
      options={{
        minimap: {
          enabled: false,
        },
        formatOnType: true,
        formatOnPaste: true,
        "semanticHighlighting.enabled": true,
        language: "json",
      }}
      schemaUri={props.schemaUri}
      value={props.value ?? undefined}
      schemaValidation="error"
      onChange={(e) => {
        props.onChange(e ?? null);
      }}
    />
  );
}
